module.exports = __webpack_public_path__ + "static/img/Dane_Rampe_mobile.b1c404b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dane_Rampe_mobile.jpg
// module id = P09f
// module chunks = 0